import React, { useEffect, useState } from "react";
import BMInput from "../comps/BMInput";
import { Checkbox, Collapse, Button, Divider, Input, Space, Tooltip, Slider, InputNumber  } from "antd";
import { Container, Draggable } from 'react-smooth-dnd';
import wrap from "../../utils/wrap"
import PresetPicker from "../../globals/styles/PresetPicker";
import { TrashIcon, PlusIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../admin/Icons";
import { HolderOutlined } from '@ant-design/icons';
import { makeKey, tt_sbs_txt_padding_x, tt_sbs_txt_padding_y } from "../../utils/Utils";
import RichTextEditor from "./RichTextEditor";
export default function Tables(props) {

    const { setData = () => { }, container=true, data = {}, extra = false, dataRow = {}, setDataRow = {} } = props;
    const [selected, setSelected] = useState("");
    const [ rows , setRows ] = useState(props.rows.map(item => {
        return { ...item }
    }));

    const [columns, setColumns] = useState(props.columns.map(item => {
        return { ...item, "id": makeKey() }
    }));

    const save = () => {
        setData({ ...data, "columns": columns, "rows": rows});
    }

    useEffect(save, [columns, rows])

    const updateColumn = (_key, _value, _index) => {
        let _arr = [...columns];
        _arr[_index][_key] = _value;
        setColumns(_arr);

    }
    
    const updateRow = (key, index, colIndex, value) => {
        let _arr = [...rows];
        let _col = [...columns];
        let targetRow = index * _col.length;
        
        _arr[targetRow + colIndex][key] = value;
        setRows(_arr);
        setSelected(dataRow[index].id);
    }

    const removeColumn = (_index) => {
        let _arr = [...columns];
        let _row = [...rows];

        _arr.splice(_index, 1);


        for (let i = 0; i < dataRow.length; i++) {
            _row.splice(_index + i * _arr.length, 1);
        }
        
        setColumns(_arr);
        setRows(_row);
        setSelected("");
    }

    const removeRow = (_index) => {
        let _col = [...columns];
        let _arr = [...rows];

        _arr.splice(_index * _col.length, _col.length);
        setRows(_arr);
        setSelected("");
    }

    const addColumn = () => {
        let _arr = [...columns];
        let _row = [...rows];

        _arr.push({
            header: `Column ${columns.length + 1}`, 
            id: makeKey(), 
            padding_x: 0, 
            padding_y: 0, 
            text_align:"left", 
            header_preset: 0, 
            min_width: 200,
        });

        for (let i = 1; i < dataRow.length + 1; i++) {
            let idToAdd = (_arr.length * i) - 1;
            _row.splice(idToAdd, 0, { data: `Row ${i} Column ${_arr.length}`, check: false });
        }

        setRows(_row);
        setSelected(_arr.length - 1);
        setColumns(_arr);
    }

    const addRow = () => {
        let count = 0;
        let _arr = [...rows];
        let _rows = [...dataRow];
        let _col = [...columns];
        
        for (const col of _col) {
            _arr.push({ data: `Row ${_rows.length + 1} Column ${++count}`, check: false });
        }

        setRows(_arr);
        setSelected(_arr.length - 1);
    }

    const formatter = (value) => `${value}px`;

    const drawColumn = (_col = {}, _index) => {
        return (
            <div key={_index}>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLUMN WIDTH</Divider>
                    <div className="float-flex">
                        <Slider
                            style={{ "width": "90px" }}
                            min={0}
                            max={1000}
                            disabled={!data.fixed_width}
                            tooltip={{
                                formatter,
                            }}
                            formatter={(_v) => `${_v}px`}p
                            onAfterChange={(_v) => updateColumn( "min_width", _v, _index)}
                            defaultValue={_col.min_width}
                        />
                        <InputNumber
                            className="simple-num-input"
                            min={0}
                            max={1000}
                            disabled={!data.fixed_width}
                            style={{ margin: '0 16px', "width": "40px" }}
                            value={_col.min_width}
                            onBlur={(_v) => updateColumn( "min_width", _v.target.value, _index)}
                            controls={false}
                            precision={0}
                        />

                    </div>
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADER PRESET</Divider>
                    <PresetPicker value={_col.header_preset} onChange={(e) => updateColumn("header_preset", e, _index)} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADER</Divider>
                    <RichTextEditor container={container} text_align={_col.text_align} onFinish={(e) => updateColumn("header", e, _index)} hold value={_col.header} padding_x={_col.padding_x} padding_y={_col.padding_y} paragraph_preset={_col.header_preset} background_colour={data.header_bg_colour}/> 
                </div>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => updateColumn("text_align", "left", _index)} style={{ "color": (_col.text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => updateColumn("text_align","center", _index)} style={{ "color": (_col.text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => updateColumn("text_align", "right", _index)} style={{ "color": (_col.text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <Space>
                        <BMInput value={_col.padding_x} onChange={(_v) => updateColumn("padding_x", _v, _index)} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_sbs_txt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={_col.padding_y} onChange={(_v) => updateColumn("padding_y", _v, _index)} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_sbs_txt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
            </div>
        )
    }

    const drawRow = (row, index) => {
        return (
            <div key={index}>
                {columns.map((column, colIndex) => {
                    const cellData = row[colIndex] || { data: "", check: false };
                    return (
                        <div key={colIndex}>
                            <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ROW {index + 1} COLUMN {colIndex + 1}</Divider>
                            <RichTextEditor onFinish={(e) => updateRow("data", index, colIndex, e)} hold paragraph_preset={data.row_preset} value={cellData.data} padding_x={column.padding_x} padding_y={column.padding_y} background_colour={data.row_colour}/> 
                            <div className="shim" />
                            <div>
                                <Checkbox 
                                    checked={cellData.check} 
                                    onChange={(e) => updateRow("check", index, colIndex, e.target.checked)}>
                                    <small>Check icon</small>
                                </Checkbox>  
                            </div>
                            <div className="shim" /><div className="shim" />
                        </div>
                    );
                })}
            </div>
        );
    }
    
    const ExpandDiv = (props) => {
        const { id = "", title = "", extra = "" } = props;
        const [expanded, setExpanded] = useState(id === selected);

        return (
            <div>
                <div className="float-flex">
                    <div onClick={() => setSelected((id === selected) ? "" : id)} style={{ "cursor": "pointer" }}><Space>{(expanded) ? "-" : "+"}{title}</Space></div>
                    <div>{extra}</div>
                </div>

                <div className="shim" />
                {(expanded && <div>{props.children}</div>)}
            </div>
        )
    }

    const drawColumns = () => {
        return columns.map((item, index) => {
            return (
                <Draggable key={item.id}>
                    <Space>
                        <div style={{ "cursor": "pointer" }} className="img_drag_handle">
                            {((selected !== item.id) && <HolderOutlined style={{ "fontSize": "14px", "opacity": "0.5" }} />)}
                        </div>
                        <div style={{ "width": (selected === item.id) ? "237px" : "223px" }}>
                            <ExpandDiv
                                id={item.id}
                                title={<><div style={{ "lineHeight": "10px" }}><wrap.tags small color="#e77e21">{(item.alt) ? item.alt : `Column ${index + 1}`} </wrap.tags></div></>}
                                extra={<><div style={{ "marginTop": "-2px" }}><Button onClick={() => removeColumn(index)} type="link" icon={<TrashIcon />} size="small" /></div></>}
                            >
                                {drawColumn(item, index)}
                            </ExpandDiv>
                        </div>
                    </Space>
                </Draggable>
            )
        })
    }

    const drawRows = () => {
        return dataRow.map((item, index) => {
            return (
                <Draggable key={item.id}>
                    <Space>
                        <div style={{ "cursor": "pointer" }} className="img_drag_handle">
                            {((selected !== item.id) && <HolderOutlined style={{ "fontSize": "14px", "opacity": "0.5" }} />)}
                        </div>
                        <div style={{ "width": (selected === index) ? "237px" : "223px" }}>
                            <ExpandDiv
                                id={item.id}
                                title={<><div style={{ "lineHeight": "10px" }}><wrap.tags small color="#e77e21">{(item.alt) ? item.alt : `Row ${index  + 1}` } </wrap.tags></div></>}
                                extra={<><div style={{ "marginTop": "-2px" }}><Button onClick={() => removeRow(index)} type="link" icon={<TrashIcon />} size="small" /></div></>}
                            >
                                {drawRow(item, index)}
                            </ExpandDiv>
                        </div>
                    </Space>
                </Draggable>
            )
        })
    }

    const onDropColumn = (dropResult) => {

        if (!dropResult.removedIndex && dropResult.removedIndex !== 0) return;

        const newItems = [...columns];
        const newRows = [...dataRow];
        newItems.splice(dropResult.addedIndex, 0, newItems.splice(dropResult.removedIndex, 1)[0]);

        const flattened = newRows.flatMap(item => {
            const { id, ...rest } = item; 
            return Object.values(rest).map(value => ({ data: value.data, check: value.check }));
        });

        for (let i = 0; i < newRows.length; i++) {
            const colNum = i * newItems.length;
            const temp = flattened[dropResult.removedIndex + colNum];
            flattened[dropResult.removedIndex + colNum] = flattened[dropResult.addedIndex + colNum];
            flattened[dropResult.addedIndex + colNum] = temp;
        }
        

        setColumns(newItems);
        setRows(flattened);
    };

    const onDropRow = (dropResult) => {
        if (!dropResult.removedIndex && dropResult.removedIndex !== 0) return;
    
        const newItems = [...dataRow];
        newItems.splice(dropResult.addedIndex, 0, newItems.splice(dropResult.removedIndex, 1)[0]);
    
        const flattened = newItems.flatMap(item => {
            const { id, ...rest } = item;
            return Object.values(rest).map(value => ({ data: value.data, check: value.check }));
        });
    
        setRows(flattened);
    };

    return (
        <>
            <div className="float-flex">
                <div style={{ "width": "50px" }} orientationMargin={0} orientation="left" plain className="simple-divider ant-divider-with-text">COLUMN</div>
                <div style={{ "marginTop": "-5px" }}><Button onClick={() => addColumn()} type="link" icon={<PlusIcon />} size="small" /></div>
            </div>
            <Divider style={{ "margin": "5px 0px" }} dashed />

            <Container dragHandleSelector=".img_drag_handle" lockAxis="y" onDrop={onDropColumn}>
                {drawColumns()}
            </Container>

            <div className="float-flex">
                <div style={{ "width": "50px" }} orientationMargin={0} orientation="left" plain className="simple-divider ant-divider-with-text">ROW</div>
                <div style={{ "marginTop": "-5px" }}><Button onClick={() => addRow()} type="link" icon={<PlusIcon />} size="small" /></div>
            </div>
            <Divider style={{ "margin": "5px 0px" }} dashed />

            <Container dragHandleSelector=".img_drag_handle" lockAxis="y" onDrop={onDropRow}>
                {drawRows()}
            </Container>
        </>
    )
}